module.exports = __webpack_public_path__ + "static/media/certificate.3e6e4002.svg";